module.exports = __webpack_public_path__ + "img/44.01034276.png";